module.exports = __webpack_public_path__ + "fonts/trust_sans_black_it-webfont.3795fd24.woff2";